import Vue from "vue";
import VueRouter from "vue-router";
import { publicPath, routerMode } from "@/config/settings";
Vue.use(VueRouter);
import Layout from "@/layout";

export const constantRoutes = [
  {
    name: "Login",
    path: "/login",
    component: () => import("@/views/login"),
    meta: { title: "登录" },
  },
  {
    name: "Register",
    path: "/register",
    component: () => import("@/views/register"),
    meta: { title: "注册" },
  },
  {
    name: "401",
    path: "/401",
    component: () => import("@/views/error/401"),
    meta: { title: "无权限访问" },
  },
  {
    name: "404",
    path: "/404",
    component: () => import("@/views/error/404"),
    meta: { title: "未找到该页面" },
  },
  {
    name: "DashboardReserve",
    path: "/dashboard/reserve",
    component: () => import("@/views/dashboard/reserve/index"),
    meta: { title: "预约记录" },
  },
  {
    name: "DashboardReserveMan",
    path: "/dashboard/reserve/man",
    component: () => import("@/views/dashboard/reserve/man"),
    meta: { title: "立即预约" },
  },
  {
    name: "DashboardReserveCar",
    path: "/dashboard/reserve/car",
    component: () => import("@/views/dashboard/reserve/car"),
    meta: { title: "立即预约" },
  },
  {
    name: "TaskDetail",
    path: "/public/task-detail",
    component: () => import("@/views/public/task-detail/index"),
    meta: { title: "发货明细" },
  },
  {
    name: "TaskAmap",
    path: "/public/task-amap",
    component: () => import("@/views/public/task-amap/index"),
    meta: { title: "行驶路线" },
  },
];

export const asyncRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "/404",
    children: [
      {
        name: "Dashboard",
        path: "/dashboard",
        component: () => import("@/views/dashboard"),
        // meta: { title: '首页', permissions: [131, 211] }
        meta: {
          title: "首页",
          permissions: [
            11, 12, 13, 21, 22, 31, 32, 41, 42, 43, 44, 51, 52, 61, 62, 71, 72,
            73, 81, 82, 83, 91, 92, 93, 101, 102, 111, 112, 121, 122, 131, 132,
            133, 141, 142, 143, 144, 145, 146, 151, 152, 153, 154, 161, 162,
            163, 164, 171, 172, 173, 174, 175, 176, 177, 181, 182, 183, 184,
            191, 192, 193, 194, 201, 202, 203, 204, 205, 211, 221, 231, 241,
            242, 243, 244, 245, 251, 252, 261, 262, 263, 271, 272, 281, 282,
            283, 291, 292, 293, 301, 302, 303, 311, 312, 321, 322, 331, 332,
            421, 422, 423, 424, 426, 428, 425, 427, 441, 431,
          ],
        },
      },
      {
        name: "Service",
        path: "/service",
        component: () => import("@/views/service"),
        meta: {
          title: "业务",
          permissions: [
            11, 12, 13, 14, 21, 22, 31, 32, 41, 42, 43, 44, 51, 52, 61, 62, 71,
            72, 73, 81, 82, 83, 91, 92, 93, 101, 102, 111, 112, 121, 122, 131,
            132, 133, 141, 142, 143, 144, 145, 146, 151, 152, 153, 154, 161,
            162, 163, 164, 171, 172, 173, 174, 175, 176, 177, 181, 182, 183,
            184, 191, 192, 193, 194, 201, 202, 203, 204, 205, 211, 221, 231,
            241, 242, 243, 244, 245, 251, 252, 261, 262, 263, 271, 272, 281,
            282, 283, 291, 292, 293, 301, 302, 303, 311, 312, 321, 322, 331,
            332, 421, 422, 423, 424, 426, 428, 425, 427, 441, 431, 511, 512,
            513, 501, 502, 503, 491, 492,
          ],
        },
      },
      {
        name: "Report",
        path: "/report",
        component: () => import("@/views/report"),
        meta: { title: "报表", permissions: [211] },
      },
    ],
  },
  {
    path: "/dashboard",
    component: Layout,
    children: [
      {
        name: "DashboardTimeLine",
        path: "/dashboard/time-line",
        component: () => import("@/views/dashboard/time-line"),
        meta: { title: "运营记录" },
      },
      {
        name: "DashboardVisitor",
        path: "/dashboard/visitor",
        component: () => import("@/views/dashboard/order/index"),
        meta: { title: "预约记录" },
      },
      {
        name: "DashboardVisitorCreate",
        path: "/dashboard/visitor/order/create",
        component: () => import("@/views/dashboard/order/index"),
        meta: { title: "预约记录" },
      },
      {
        name: "DashboardSupplier",
        path: "/dashboard/supplier",
        component: () => import("@/views/dashboard/order/index"),
        meta: { title: "预约记录" },
      },
      {
        name: "DashboardSupplier",
        path: "/dashboard/supplier/order/create",
        component: () => import("@/views/dashboard/order/index"),
        meta: { title: "预约记录" },
      },
      {
        name: "DashboardOrder",
        path: "/dashboard/order",
        component: () => import("@/views/dashboard/order/index"),
        meta: { title: "预约记录" },
      },
      {
        name: "DashboardOrderMan",
        path: "/dashboard/order/man",
        component: () => import("@/views/dashboard/order/man"),
        meta: { title: "立即预约" },
      },
      {
        name: "DashboardOrderCar",
        path: "/dashboard/order/car",
        component: () => import("@/views/dashboard/order/car"),
        meta: { title: "立即预约" },
      },
      {
        name: "DashboardOrderSelfWeighing",
        path: "/dashboard/order/self-weighing/:type",
        component: () => import("@/views/dashboard/order/self-weighing"),
        meta: { title: "自助过磅" },
      },
    ],
  },
  {
    path: "/service",
    component: Layout,
    children: [
      {
        name: "ServiceBussinessVerify",
        path: "/service/business/verify",
        component: () => import("@/views/service/business/verify/new"),
        meta: { title: "人员预约审核", permissions: [11, 12] },
      },
      {
        name: "ServiceBussinessVerifyCar",
        path: "/service/business/verify-car",
        component: () => import("@/views/service/business/verify-car/index"),
        meta: { title: "车辆预约审核", permissions: [14, 13] },
      },
      {
        name: "ServiceBussinessOwdr",
        path: "/service/business/owdr",
        component: () => import("@/views/service/business/owdr/index"),
        meta: { title: "过磅检测", permissions: [491, 492] },
      },
      {
        name: "ServiceBussinessOwdrCreate",
        path: "/service/business/owdr/create",
        component: () => import("@/views/service/business/owdr/create"),
        meta: { title: "添加过磅检测", permissions: [492] },
      },
      {
        name: "ServiceBussinessWater",
        path: "/service/business/water",
        component: () => import("@/views/service/business/water/index"),
        meta: { title: "水份检测", permissions: [21, 22] },
      },
      {
        name: "ServiceBussinessWaterCreate",
        path: "/service/business/water/create",
        component: () => import("@/views/service/business/water/create"),
        meta: { title: "添加水份检测", permissions: [22] },
      },
      {
        name: "ServiceBussinessMaterial",
        path: "/service/business/material",
        component: () => import("@/views/service/business/material/index"),
        meta: { title: "粉料检测", permissions: [31, 32] },
      },
      {
        name: "ServiceBussinessMaterialCreate",
        path: "/service/business/material-check/create",
        component: () => import("@/views/service/business/material/create"),
        meta: { title: "粉料检测申请" },
      },
      {
        name: "ServiceBussinessMaterialCreate",
        path: "/service/business/material/create",
        component: () => import("@/views/service/business/material/create"),
        meta: { title: "粉料检测申请" },
      },
      {
        name: "ServiceBussinessMaterialUpdate",
        path: "/service/business/material/update",
        component: () => import("@/views/service/business/material/update"),
        meta: { title: "粉料检测审核", permissions: [32] },
      },
      {
        name: "ServiceBussinessQueue",
        path: "/service/business/queue",
        component: () => import("@/views/service/business/queue/index"),
        meta: { title: "装车排队", permissions: [41, 42, 43, 44] },
      },
      {
        name: "ServiceBussinessUnloadingQueue",
        path: "/service/business/unloading-queue",
        component: () =>
          import("@/views/service/business/unloading-queue/index"),
        meta: { title: "卸料排队", permissions: [531, 533, 534] },
      },
      {
        name: "ServiceBussinessUnloadingQueueCreate",
        path: "/service/business/unloading-queue/create",
        component: () =>
          import("@/views/service/business/unloading-queue/create"),
        meta: { title: "新增卸料排队", permissions: [533] },
      },
      {
        name: "ServiceBussinessWarning",
        path: "/service/business/warning",
        component: () => import("@/views/service/business/warning/index"),
        meta: { title: "告警记录", permissions: [451, 452] },
      },
      {
        name: "ServiceBussinessShipRecord",
        path: "/service/business/ship-record",
        component: () => import("@/views/service/business/ship-record/index"),
        meta: { title: "发货处理", permissions: [511, 512, 514, 515] },
      },
      {
        name: "ServiceBussinessReturnConcrete",
        path: "/service/business/return-concrete",
        component: () =>
          import("@/views/service/business/return-concrete/index"),
        meta: { title: "退砼处理", permissions: [501, 502] },
      },
      {
        name: "VehicleApply",
        path: "/service/business/vehicle",
        component: () => import("@/views/service/business/vehicle/index"),
        meta: { title: "加油申请", permissions: [421, 422, 423, 424, 426] },
      },
      {
        name: "VehicleCheckApply",
        path: "/service/business/vehicle-apply",
        component: () => import("@/views/service/business/vehicleApply/index"),
        meta: { title: "审核加油申请", permissions: [428, 425, 427] },
      },
      {
        name: "ItemReceipt",
        path: "/service/business/item-receipt",
        component: () => import("@/views/service/business/item-receipt/index"),
        meta: { title: "出库领用申请", permissions: [428, 425, 427] },
      },
      {
        name: "ItemReceiptCraate",
        path: "/service/business/item-receipt/create",
        component: () => import("@/views/service/business/item-receipt/create"),
        meta: { title: "编辑物品出库申请", permissions: [428, 425, 427] },
      },
      {
        name: "ItemReceipt/Detail",
        path: "/service/business/item-receipt/detail",
        component: () => import("@/views/service/business/item-receipt/detail"),
        meta: { title: "出库领用明细", permissions: [428, 425, 427] },
      },
      {
        name: "ServiceHistoryRefuel",
        path: "/service/history/refuel",
        component: () => import("@/views/service/history/refuel/index"),
        meta: { title: "加油记录", permissions: [441] },
      },
      {
        name: "ServiceHistoryRefuelReport",
        path: "/service/history/refuel-report",
        component: () => import("@/views/service/history/refuel-report/index"),
        meta: { title: "加油报表", permissions: [431] },
      },
      {
        name: "ServiceHistoryShipRecord",
        path: "/service/history/ship-record",
        component: () => import("@/views/service/history/ship-record/index"),
        meta: { title: "发货记录", permissions: [511] },
      },
      {
        name: "ServiceHistoryReturnConcrete",
        path: "/service/history/return-concrete",
        component: () =>
          import("@/views/service/history/return-concrete/index"),
        meta: { title: "退砼记录", permissions: [501] },
      },
      {
        name: "ServiceHistoryStockcur",
        path: "/service/history/stockcur",
        component: () => import("@/views/service/history/stockcur/index"),
        meta: { title: "库存查询", permissions: [501] },
      },
      {
        name: "ServiceHistoryOilInStock",
        path: "/service/history/oil-in-stock",
        component: () => import("@/views/service/history/oil-in-stock/index"),
        meta: { title: "燃油入库", permissions: [481] },
      },
      {
        name: "ServiceSystemVehicle",
        path: "/service/system/vehicle",
        component: () => import("@/views/service/system/vehicle/index"),
        meta: { title: "车辆管理", permissions: [401, 402, 403, 404] },
      },
      {
        name: "ServiceSystemVehicleCreate",
        path: "/service/system/vehicle/create",
        component: () => import("@/views/service/system/vehicle/create"),
        meta: { title: "添加车辆", permissions: [402] },
      },
      {
        name: "ServiceSystemVehicleUpdate",
        path: "/service/system/vehicle/update",
        component: () => import("@/views/service/system/vehicle/update"),
        meta: { title: "更新车辆", permissions: [403] },
      },
      {
        name: "ServiceSystemDict",
        path: "/service/system/dict",
        component: () => import("@/views/service/system/dict/index"),
        meta: { title: "字典管理", permissions: [401, 402, 403, 404] },
      },
      {
        name: "ServiceSystemDictCreate",
        path: "/service/system/dict/create",
        component: () => import("@/views/service/system/dict/create"),
        meta: { title: "新增字典", permissions: [401, 402, 403, 404] },
      },
      {
        name: "ServiceSystemDictUpdate",
        path: "/service/system/dict/update",
        component: () => import("@/views/service/system/dict/update"),
        meta: { title: "编辑字典", permissions: [401, 402, 403, 404] },
      },
      {
        name: "ServiceSystemDict",
        path: "/service/system/dictdata",
        component: () => import("@/views/service/system/dictdata/index"),
        meta: { title: "字典数据管理", permissions: [401, 402, 403, 404] },
      },
      {
        name: "ServiceSystemDictCreate",
        path: "/service/system/dictdata/create",
        component: () => import("@/views/service/system/dictdata/create"),
        meta: { title: "新增字典数据", permissions: [401, 402, 403, 404] },
      },
      {
        name: "ServiceSystemDictUpdate",
        path: "/service/system/dictdata/update",
        component: () => import("@/views/service/system/dictdata/update"),
        meta: { title: "编辑字典数据", permissions: [401, 402, 403, 404] },
      },
      {
        name: "ServiceControlFace",
        path: "/service/control/face",
        component: () => import("@/views/service/control/face/index"),
        meta: { title: "人脸闸机", permissions: [51, 52] },
      },
      {
        name: "ServiceControlCar",
        path: "/service/control/car",
        component: () => import("@/views/service/control/car/index"),
        meta: { title: "车辆道闸", permissions: [311, 312] },
      },
      {
        name: "ServiceControlWeigh",
        path: "/service/control/weigh",
        component: () => import("@/views/service/control/weigh/index"),
        meta: { title: "地磅道闸", permissions: [251, 252] },
      },
      {
        name: "ServiceControlPort",
        path: "/service/control/port",
        component: () => import("@/views/service/control/port/index"),
        meta: { title: "卸料罐口", permissions: [61, 62] },
      },
      {
        name: "ServiceHistoryFace",
        path: "/service/history/face",
        component: () => import("@/views/service/history/face/index"),
        meta: { title: "人脸闸机", permissions: [71, 72, 73] },
      },
      {
        name: "ServiceHistoryCar",
        path: "/service/history/car",
        component: () => import("@/views/service/history/car/index"),
        meta: { title: "车辆道闸", permissions: [81, 82, 83] },
      },
      {
        name: "ServiceHistoryWeigh",
        path: "/service/history/weigh",
        component: () => import("@/views/service/history/weigh/index"),
        meta: { title: "过磅记录", permissions: [91, 92, 93] },
      },
      {
        name: "ServiceHistoryWeighUpdate",
        path: "/service/history/weigh/update",
        component: () => import("@/views/service/history/weigh/update"),
        meta: { title: "编辑过磅记录", permissions: [91, 92, 93] },
      },
      {
        name: "ServiceHistoryStore",
        path: "/service/history/store",
        component: () => import("@/views/service/history/store/index"),
        meta: { title: "骨料卸料", permissions: [301, 302, 303] },
      },
      {
        name: "ServiceHistoryPort",
        path: "/service/history/port",
        component: () => import("@/views/service/history/port/index"),
        meta: {
          title: "粉料卸料",
          permissions: [261, 262, 263, 264, 265, 266],
        },
      },
      {
        name: "ServiceHistoryPortCreate",
        path: "/service/history/port/create",
        component: () => import("@/views/service/history/port/create"),
        meta: { title: "编辑粉料卸料", permissions: [264, 265] },
      },
      {
        name: "ServiceHistoryLine",
        path: "/service/history/line",
        component: () => import("@/views/service/history/line/index"),
        meta: { title: "商砼装车", permissions: [281, 282, 283] },
      },
      {
        name: "ServiceHistoryMaterial",
        path: "/service/history/material",
        component: () => import("@/views/service/history/material/index"),
        meta: { title: "盘点记录", permissions: [291, 292, 293] },
      },
      {
        name: "ServiceProjectSwitch",
        path: "/service/project/switch",
        component: () => import("@/views/service/project/switch/index"),
        meta: { title: "生产开关", permissions: [101, 102] },
      },
      {
        name: "ServiceProjectVerify",
        path: "/service/project/verify",
        component: () => import("@/views/service/project/verify/index"),
        meta: { title: "预约审核方式", permissions: [331, 332] },
      },
      {
        name: "ServiceProjectCar",
        path: "/service/project/car",
        component: () => import("@/views/service/project/car/index"),
        meta: { title: "办公道闸", permissions: [321, 322] },
      },
      {
        name: "ServiceProjectNumber",
        path: "/service/project/number",
        component: () => import("@/views/service/project/number/index"),
        meta: { title: "骨料车数", permissions: [271, 272] },
      },
      {
        name: "ServiceProjectMessage",
        path: "/service/project/message",
        component: () => import("@/views/service/project/message/index"),
        meta: { title: "消息推送", permissions: [111, 112] },
      },
      {
        name: "ServiceProjectMessageUpdate",
        path: "/service/project/message/update",
        component: () => import("@/views/service/project/message/update"),
        meta: { title: "更新推送人群", permissions: [112] },
      },
      {
        name: "ServiceProjectLine",
        path: "/service/project/line",
        component: () => import("@/views/service/project/line/index"),
        meta: { title: "装车线", permissions: [121, 122] },
      },
      {
        name: "ServiceProjectLineUpdate",
        path: "/service/project/line/update",
        component: () => import("@/views/service/project/line/update"),
        meta: { title: "更新装车线", permissions: [122] },
      },
      {
        name: "ServiceProjectPort",
        path: "/service/project/port",
        component: () => import("@/views/service/project/port/index"),
        meta: { title: "卸料罐口", permissions: [131, 132, 133] },
      },
      {
        name: "ServiceProjectPortUpdate",
        path: "/service/project/port/update",
        component: () => import("@/views/service/project/port/update"),
        meta: { title: "更新卸料罐口", permissions: [132] },
      },
      {
        name: "ServiceSystemStaff",
        path: "/service/system/staff",
        component: () => import("@/views/service/system/staff/index"),
        meta: {
          title: "用户列表",
          permissions: [141, 142, 143, 144, 145, 146],
        },
      },
      {
        name: "ServiceSystemStaffCreate",
        path: "/service/system/staff/create",
        component: () => import("@/views/service/system/staff/create"),
        meta: { title: "添加用户", permissions: [142] },
      },
      {
        name: "ServiceSystemStaffUpdate",
        path: "/service/system/staff/update",
        component: () => import("@/views/service/system/staff/update"),
        meta: { title: "更新用户", permissions: [143] },
      },
      {
        name: "ServiceSystemDepartment",
        path: "/service/system/department",
        component: () => import("@/views/service/system/department/index"),
        meta: { title: "部门列表", permissions: [151, 152, 153, 154] },
      },
      {
        name: "ServiceSystemDepartmentCreate",
        path: "/service/system/department/create",
        component: () => import("@/views/service/system/department/create"),
        meta: { title: "添加部门", permissions: [152] },
      },
      {
        name: "ServiceSystemDepartmentUpdate",
        path: "/service/system/department/update",
        component: () => import("@/views/service/system/department/update"),
        meta: { title: "更新部门", permissions: [153] },
      },
      {
        name: "ServiceSystemRole",
        path: "/service/system/role",
        component: () => import("@/views/service/system/role/index"),
        meta: { title: "角色列表", permissions: [161, 162, 163, 164] },
      },
      {
        name: "ServiceSystemRoleCreate",
        path: "/service/system/role/create",
        component: () => import("@/views/service/system/role/create"),
        meta: { title: "添加角色", permissions: [162] },
      },
      {
        name: "ServiceSystemRoleUpdate",
        path: "/service/system/role/update",
        component: () => import("@/views/service/system/role/update"),
        meta: { title: "更新角色", permissions: [163] },
      },
      {
        name: "ServiceSystemTruck",
        path: "/service/system/truck",
        component: () => import("@/views/service/system/truck/index"),
        meta: {
          title: "货车列表",
          permissions: [171, 172, 173, 174, 175, 176, 177],
        },
      },
      {
        name: "ServiceSystemTruckCreate",
        path: "/service/system/truck/create",
        component: () => import("@/views/service/system/truck/create"),
        meta: { title: "添加货车", permissions: [172] },
      },
      {
        name: "ServiceSystemTruckUpdate",
        path: "/service/system/truck/update",
        component: () => import("@/views/service/system/truck/update"),
        meta: { title: "更新货车", permissions: [173] },
      },
      {
        name: "ServiceSystemSupplier",
        path: "/service/system/supplier",
        component: () => import("@/views/service/system/supplier/index"),
        meta: { title: "供应商列表", permissions: [181, 182, 183, 184] },
      },
      {
        name: "ServiceSystemSupplierCreate",
        path: "/service/system/supplier/create",
        component: () => import("@/views/service/system/supplier/create"),
        meta: { title: "添加供应商", permissions: [182] },
      },
      {
        name: "ServiceSystemSupplierUpdate",
        path: "/service/system/supplier/update",
        component: () => import("@/views/service/system/supplier/update"),
        meta: { title: "更新供应商", permissions: [183] },
      },
      {
        name: "ServiceSystemProduct",
        path: "/service/system/product",
        component: () => import("@/views/service/system/product/index"),
        meta: { title: "产品列表", permissions: [191, 192, 193, 194] },
      },
      {
        name: "ServiceSystemProductCreate",
        path: "/service/system/product/create",
        component: () => import("@/views/service/system/product/create"),
        meta: { title: "添加产品", permissions: [192] },
      },
      {
        name: "ServiceSystemProductUpdate",
        path: "/service/system/product/update",
        component: () => import("@/views/service/system/product/update"),
        meta: { title: "更新产品", permissions: [193] },
      },
      {
        name: "ServiceSystemMaterial",
        path: "/service/system/material",
        component: () => import("@/views/service/system/material/index"),
        meta: { title: "物料列表", permissions: [201, 202, 203, 204, 205] },
      },
      {
        name: "ServiceSystemMaterialCreate",
        path: "/service/system/material/create",
        component: () => import("@/views/service/system/material/create"),
        meta: { title: "添加物料", permissions: [202] },
      },
      {
        name: "ServiceSystemMaterialUpdate",
        path: "/service/system/material/update",
        component: () => import("@/views/service/system/material/update"),
        meta: { title: "更新物料", permissions: [203] },
      },
      {
        name: "ServiceUserPassword",
        path: "/service/user/password",
        component: () => import("@/views/service/user/password/index"),
        meta: { title: "修改密码" },
      },
      {
        name: "applyManual",
        path: "/service/manual/apply",
        component: () => import("@/views/service/manual/apply/index"),
        meta: { title: "加油申请使用说明书" },
      },
      {
        name: "managerManual",
        path: "/service/manual/manager",
        component: () => import("@/views/service/manual/manager/index"),
        meta: { title: "加油管理系统电脑端说明书" },
      },
      {
        name: "systemManual",
        path: "/service/manual/system",
        component: () => import("@/views/service/manual/system/index"),
        meta: { title: "加油管理系统移动端说明书" },
      },
      {
        name: "ServiceUserLog",
        path: "/service/user/log",
        component: () => import("@/views/service/user/log/index"),
        meta: { title: "运行日志", permissions: [221] },
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];

const router = new VueRouter({
  base: publicPath,
  mode: routerMode,
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRoutes,
});

export function resetRouter() {
  router.matcher = new VueRouter({
    base: publicPath,
    mode: routerMode,
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  }).matcher;
}

export default router;
